// extracted by mini-css-extract-plugin
module.exports = {"main":"btn_main__8z1Jl"};